export const localhostRedirectStorageKey = 'localhost_redirect';
